import { morphForWords } from 'components/shared/processes'
import Input from 'components/shared/textFields/Input'
import { TypographySecondary14 } from 'ui/typography/TypographySecondary14'

interface Props {
	value: string
	onChange: (value: string) => void
	isError?: boolean
	placeholder?: string
	unitLabel?: string
}

const CompactDaysInput = ({
	value,
	onChange,
	isError,
	placeholder = '0 дней',
	unitLabel,
}: Props) => (
	<Input
		value={value}
		onChange={e => onChange(e.target.value.replace(/\D/g, ''))}
		label=''
		hideLabel
		placeholder={placeholder}
		width='120px'
		height='54px'
		isError={Boolean(isError)}
		isMultiline={false}
		inputProps={{
			inputMode: 'numeric',
			pattern: '[0-9]*',
			style: { textAlign: 'center' },
		}}
		endAdornment={
			value ? (
				<TypographySecondary14>
					{unitLabel ?? morphForWords(Number(value), ['день', 'дня', 'дней'])}
				</TypographySecondary14>
			) : null
		}
	/>
)

export default CompactDaysInput
